function Error() {
    return (
      <div>
        <h3>Error 500. Problemas de servidor :(</h3>
      </div>
    );
  }
  
  export default Error;
  